/* eslint-disable @typescript-eslint/no-explicit-any */
import { ICompany } from "../types/company";
import { ICompanySettings } from "../types/intake/companySettings";
import backendApi from "./backendApi";
import { showSnackbar } from "./snackbar.service";

const routePrefix = "company";

export default {
  async getMyCompanySettings(): Promise<any> {
    try {
      const result = await backendApi()?.get(`company-settings`);
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not load company settings."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not load company settings."
        );
        return null;
      }
    }
  },
  async updateMyCompanySettings(
    updateData: Partial<ICompanySettings>
  ): Promise<any> {
    try {
      const result = await backendApi()?.post(`company-settings`, {
        updateData,
      });
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not save company settings."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not save company settings."
        );
        return null;
      }
    }
  },
  async fetchCompanyShallowList(): Promise<any> {
    try {
      const result = await backendApi()?.get(`${routePrefix}/shallow-list`);
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not load companies."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not load companies."
        );
        return null;
      }
    }
  },
  async getMyCompany(): Promise<any> {
    try {
      const result = await backendApi()?.get(`${routePrefix}/my`);
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not load your company."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not load your company."
        );
        return null;
      }
    }
  },
  async getMyClients(): Promise<any> {
    try {
      const result = await backendApi()?.get(`${routePrefix}/my-clients`);
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not load your clients."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not load your clients."
        );
        return null;
      }
    }
  },
  async fetchAllCompanies(): Promise<any> {
    try {
      const result = await backendApi()?.get(`${routePrefix}/all`);
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not load the companies."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not load the companies."
        );
        return null;
      }
    }
  },
  async addNewCompany(companyInfo: ICompany): Promise<any> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/create`, {
        ...companyInfo,
      });
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not save the company."
        );
        return null;
      }
      showSnackbar(
        "success",
        "Success",
        result?.data.message || "Company created."
      );
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not save the company."
        );
        return null;
      }
    }
  },
  async updateCompany(updateInfo: ICompany, companyId?: string): Promise<any> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/update`, {
        updateInfo,
        companyId,
      });
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not update the company."
        );
        return null;
      }
      showSnackbar(
        "success",
        "Success",
        result?.data.message || "Company updated."
      );
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not update the company."
        );
        return null;
      }
    }
  },
  async deleteCompanies(ids: string[]): Promise<any> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/delete`, {
        ids,
      });
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not delete the companies."
        );
        return null;
      }
    }
  },
};
